/**
 * Client mirror of server pickPrimaryApplicationTypeId —
 * prefer role:start / primaryApplicationTypeId over [0].
 */
export function pickPrimaryApplicationTypeId(routing = {}, preferredId = null) {
  const preferred = String(preferredId || '').trim();
  if (preferred) return preferred;
  if (routing?.primaryApplicationTypeId) return String(routing.primaryApplicationTypeId);
  const apps = Array.isArray(routing?.applicationTypes) ? routing.applicationTypes : [];
  const start = apps.find((t) => t?.role === 'start' && t?.id);
  if (start?.id) return String(start.id);
  const ids = routing?.applicationTypeIds
    || apps.map((t) => t?.id).filter(Boolean)
    || [];
  if (Array.isArray(ids) && ids[0]) return String(ids[0]);
  return null;
}

export function pickPrimaryApplicationType(routing = {}, preferredId = null) {
  const id = pickPrimaryApplicationTypeId(routing, preferredId);
  if (!id) return null;
  const apps = Array.isArray(routing?.applicationTypes) ? routing.applicationTypes : [];
  return apps.find((t) => t?.id === id) || { id };
}
